module.exports = __webpack_public_path__ + "static/media/star-rchic.21d780f8.png";